module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transportation panel"
  }, [_c('h4', {
    staticClass: "mb-3 pb-3 border-bottom-light"
  }, [_vm._v("Transport")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex"
  }, [_c('label', [_vm._v("Include transportation?")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "ml-auto",
    attrs: {
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.hasTransportation),
      callback: function($$v) {
        _vm.hasTransportation = $$v
      },
      expression: "hasTransportation"
    }
  })], 1)]), _vm._v(" "), (_vm.hasTransportation) ? _c('div', [_c('transport-form', {
    on: {
      "updateFields": _vm.updateFields
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-73d15d37", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d15d37"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Transport.vue
// module id = 2044
// module chunks = 0